export const COLLECTION_BUMP_PRODUCTS = 'COLLECTION_BUMP_PRODUCTS';
export const COLLECTION_SHOW_MORE_PRODUCTS = 'COLLECTION_SHOW_MORE_PRODUCTS';
